"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const LinkProvider_1 = require("./LinkProvider");
function Link(props) {
    return (React.createElement(LinkProvider_1.LinkContext.Consumer, null, context => React.createElement(context.Link, Object.assign({}, props))));
}
exports.default = Link;
//# sourceMappingURL=Link.js.map